import React,{useContext} from 'react';
import Node from './Node';
import NodeContext from '../../contexts/NodeContext';
import RichTextInput from '../Inputs/RichTextInput';

/**
 * NoteNode - A node specifically designed for longer text content
 * Supports rich text formatting, multi-line content, and auto-resizing
 */
export default function NoteNode({id,data,selected,...props}) {
    const [setNodeValue,getNodeValue]=useContext(NodeContext);

    const handleTextChange=(newHtml) => {
        setNodeValue(id,newHtml,'data.text');
    };

    const handleFontSizeChange=(newSize) => {
        setNodeValue(id,newSize,'data.fontSize');
    };

    return (
        <Node
            nodeId={id}
            className='relative bg-yellow-100 rounded-md shadow-sm border border-yellow-200'
            selected={selected}
            approved={typeof data?.approved==='boolean'? data?.approved:true}
            resizable={true}
            keepAspectRatio={false}
            {...props}
            data={data}
        >
            <div className='p-3 min-h-[80px]'>
                <RichTextInput
                    value={data?.text||''}
                    onChange={handleTextChange}
                    placeholder='Enter your note here...'
                    fontSize={data?.fontSize||'medium'}
                    showToolbar={selected}
                    className='text-sm'
                />
            </div>
        </Node>
    );
}
